<template>
  <div>
    <b-alert
      variant="success"
      :show="showAlert_success"
      @dismissed="showAlert_success=false"
    >{{alert_success_message}}</b-alert>
    <b-container fluid>
      <b-breadcrumb class="mt-3 mb-3" :items="breadcrumb_items"/>

      <b-card class="mb-1">
        <b-form-group id="grp_txt_tracking_number" label="Tracking Number:" label-for="txt_tracking_number" label-size="sm">
          <b-form-input id="txt_tracking_number" type="text" required placeholder v-model="tracking.tracking_number"></b-form-input>
        </b-form-group>
        
        <b-form-group id="grp_txt_attention" label="Attention:" label-for="txt_attention" label-size="sm">
          <b-form-input id="txt_attention" type="text" required placeholder v-model="tracking.attention"></b-form-input>
        </b-form-group>

        <b-form-group id="grp_txt_phone" label="Phone:" label-for="txt_phone" label-size="sm">
          <b-form-input id="txt_phone" type="text" required placeholder v-model="tracking.phone"></b-form-input>
        </b-form-group>

        <b-form-group id="grp_txt_address" label="Address:" label-for="txt_address" label-size="sm">
          <b-form-input id="txt_address" type="text" required placeholder v-model="tracking.address"></b-form-input>
        </b-form-group>

        <b-form-group id="grp_txt_remark" label="Remark:" label-for="txt_remark" label-size="sm">
          <b-form-input id="txt_remark" type="text" required placeholder v-model="tracking.remark"></b-form-input>
        </b-form-group>

        <b-button class="float-right" type="submit" variant="primary" @click="submitForm()">Submit</b-button>

      </b-card>
    </b-container>
  </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";

const fields = [
  {
    key: "order_id",
    label: "Order#"
  },
  {
    key: "barcode",
    label: "Barcode"
  },
  {
    key: "attention",
    label: "Attention"
  },
  {
    key: "phone",
    label: "Phone"
  },
  {
    key: "status",
    label: "Status"
  },
  {
    key: "schedule_date",
    label: "Scheduled Date"
  },
  {
    key: "pod_image",
    label: "POD Record"
  },
  {
    key: "carried_by",
    label: "Carried by"
  },
  {
    key: "updated_at",
    label: "Last Updated"
  }
];

export default {
  name: "ChangeRequest",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT"],
  components: {
    barcode: VueBarcode
  },
  data() {
    return {
      breadcrumb_items: [
        {
          text: "Trackings",
          to: { name: "trackings" }
        },
        {
          text: "Edit",
          active: true
        }
      ],
      tracking : {},
      history_items: [],
      history_fields: [
        {
          key: "updated_at",
          label: "Updated at"
        },
        {
          key: "status",
          label: "Status"
        },
        {
          key: "pod_image",
          label: "POD"
        },
        {
          key: "updated_by",
          label: "Updated by"
        }
      ],
      loader: false,
      items: [],
      fields: fields,
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      manual_return_order_id: "",
      updating_item: false,
      search_criteria: {
        keyword: "",
        status_selected: null
      },
      status_options: [
        {
          value: null,
          text: "All Status"
        },
        {
          value: "Pending",
          text: "Pending"
        },
        {
          value: "In-Transit",
          text: "In-Transit"
        },
        {
          value: "Returning to GOLS Warehouse",
          text: "Returning to GOLS Warehouse"
        },
        {
          value: "Successful Delivery",
          text: "Successful Delivery"
        },
        {
          value: "Returned to Warehouse",
          text: "Returned to Warehouse"
        }
      ],
      reschedule_type_selected: "before",
      reschedule_type_options: [
        {
          value: "before",
          text: "before"
        },
        {
          value: "on",
          text: "on"
        },
        {
          value: "after",
          text: "after"
        }
      ],
      reschedule_date: moment().format("YYYY-MM-DD"),
      showAlert_success: false,
      alert_success_message: "",
      user_id : false
    };
  },
  async created() {
    await this.getTracking();
    this.initialized = true;

    if(localStorage.getItem('user')){
      let user_obj = JSON.parse(localStorage.getItem('user'));
      this.user_id = user_obj.user_id;
    }
  },
  mounted() {
    this.loader = this.$loading.show({
      isFullPage: true,
      canCancel: false
    });
  },
  methods: {
    displayDate(d) {
      if (d) {
        return moment(d).format("YYYY-MM-DD");
      } else {
        return "/";
      }
    },

    async getTracking() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "tracking_get.php",
        data: {
          tracking_id: this.$route.params.id
        }
      });

      if(response.data.trackings[0].attention_driver){
        response.data.trackings[0].attention = response.data.trackings[0].attention_driver;
      }

      if(response.data.trackings[0].phone_driver){
        response.data.trackings[0].phone = response.data.trackings[0].phone_driver;
      }

      if(response.data.trackings[0].address_driver){
        response.data.trackings[0].address = response.data.trackings[0].address_driver;
      }

      this.tracking = response.data.trackings[0];
      this.items.push(this.tracking);

      this.history_items = response.data.tracking_status_historys;
      this.loader.hide();
    },

    showModal_reschedule_tracking(item) {
      this.updating_item = item;
      this.reschedule_type_selected = "before";
      this.reschedule_date = moment().format("YYYY-MM-DD");
      this.$refs.modal_reschedule_tracking.show();
    },

    hideModal_reschedule_tracking() {
      this.$refs.modal_reschedule_tracking.hide();
    },

    submitForm() {
      this.updateTracking(this.tracking);
    },

    async updateTracking(
      tracking_obj
    ) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "tracking_detail_update.php",
        data: {
          id: tracking_obj.id,
          tracking_number: tracking_obj.tracking_number,
          attention : tracking_obj.attention,
          phone : tracking_obj.phone,
          address : tracking_obj.address,
          remark: tracking_obj.remark,
          user_id: this.user_id
        }
      });

      if (response.data.status == "success") {
        this.alert_success_message = `Tracking #${tracking_obj.tracking_number} Update Successfully.`;
        this.showAlert_success = true;
        setTimeout(() => {
          this.showAlert_success = false;
          this.alert_success_message = "";
        }, 3000);
        this.getTracking();
      } else {
      }
    }
  }
};
</script>

<style>
th,
td {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/ChangeRequest.vue